import styles from './index.module.scss';
import Script from 'next/script'
import {useEffect} from "react";

function isCalendlyEvent(e) {
    return e.data.event &&
        e.data.event.indexOf('calendly') === 0;
}

export default function Calendar({data, onChange, submit}) {
    useEffect(() => {
        const handleEvent = (e) => {
            if (isCalendlyEvent(e)) {
                if (e.data.event === 'calendly.event_scheduled') {
                    onChange('calendly_event', e.data.payload.event.uri);
                    onChange('calendly_invitee', e.data.payload.invitee.uri);
                    submit();
                }
            }
        }
        window.addEventListener('message', handleEvent);
        return () => {
            window.removeEventListener('message', handleEvent);
        }
    }, [submit, onChange]);

    const onCalendlyLoad = () => {
        window.Calendly.initInlineWidget({
            "url": 'https://calendly.com/mouna-ninjaz/30min',
            "parentElement": document.getElementById('calendar'),
            "prefill": {
                "name": data.full_name,
                "email": data.email,
            },
            "utm": {}
        });
    }

    return (
        <div className={styles.container}>
            <h2>Schedule Your Free Consultation</h2>
            <div id="calendar" className={styles.calendarContainer} data-auto-load="false"></div>
            <Script type="text/javascript" src="https://assets.calendly.com/assets/external/widget.js" onLoad={onCalendlyLoad} />
        </div>
    )
}